import { handleActions } from "redux-actions";

export default handleActions(
  {
    INCENTIVES_PUBLIC_GET: {
      PENDING: () => ({
        incentives: [],
      }),
      FULFILLED: (state, action) => ({
        incentives: action.payload.incentives,
      }),
    },
  },
  {},
  { namespace: "_" }
);
